import { render } from "./EditTypeHospitalisation.vue?vue&type=template&id=5b7ecae0&scoped=true"
import script from "./EditTypeHospitalisation.vue?vue&type=script&lang=js"
export * from "./EditTypeHospitalisation.vue?vue&type=script&lang=js"

import "./EditTypeHospitalisation.vue?vue&type=style&index=0&id=5b7ecae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7ecae0"]])

export default __exports__